// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/background1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app {
    height: 100%
}


html,
body {
    position: relative;
    height: 100%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(0, 0, 0, 1) 0%, rgba(38, 11, 11, 1) 0%, rgba(40, 8, 8, 1) 47%, rgba(33, 28, 28, 1) 100%);
}

body {
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0;
    padding: 0;
}

h5 {
    font-family: 'Raleway', sans-serif;
}

.logo {
    height: 90px;
}


.rotateOut {
    animation: rotateOut 3s linear infinite;
}

.rotate {
    animation: rotate 3s linear infinite;
}

@keyframes rotateOut {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(-360deg);
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


.weight {
    color: #EE2D2E;
    font-weight: bold;
}

.swiper {
    width: 100%;
    height: 100%;
}

.link {
    color: #fff;
    text-decoration: none;
}

.swiper-slide {
    font-size: 18px;
    color: #fff;
    box-sizing: border-box;
}

.parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 130%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}


.swiper-container {
    position: relative;
}

.MuiInputLabel-root {
    color: #fff !important;
}

.swiper-nav-btn {
    position: absolute;
    top: 0;
    z-index: 100000;
    height: 100%;
    width: 100px;
    border: none;
    background-color: #0E1513;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

.nav-link {
    display: flex;
    align-items: center;
    text-decoration: none;
}

.swiper-nav-btn:hover {
    background-color: #3b2b2b;
}

.loader {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #000;
    z-index: 1000000;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.loader img {
    width: 100px;
    height: 100px;
}

.left-side {
    left: 0;
}

.right-side {
    right: 0;
}


.swiper-container .swiper-pagination {
    position: absolute;
    bottom: 0 !important; /* Змініть це значення, щоб контролювати відстань пагінації від верхньої частини Swiper */
    left: 0;
    right: 0;
    text-align: center; /* Щоб центрувати пагінацію */
    padding: 10px 0;
    background-color: #5d1f1f;
    width: 90% !important;
    margin: 0 auto;
    z-index: 1000000;
    border-radius: 5px; /* заокруглені кути, якщо вам це подобається */
}


/* Стилі для айтемів пагінації */
.swiper-container .swiper-pagination-bullet {
    background-color: #EE2D2E !important; /* червоний фон для айтемів */
    width: auto !important;
    height: auto !important;
    color: white; /* білий текст */
    padding: 5px 10px !important; /* відступи всередині айтема */
    border-radius: 2px !important; /* заокруглені кути */
    font-size: 20px; /* розмір шрифту */
    white-space: nowrap; /* переконайтеся, що текст не переноситься на новий рядок */
    font-weight: bold;
}

.swiper-container .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {
    background-color: inherit !important;
    color: #fff !important;
    opacity: 1 !important;
}

/* Стилі для активного айтему пагінації */
.swiper-container .swiper-pagination-bullet-active {
    background-color: #EE2D2E; /* інший колір для активного айтема */
    border-radius: 5px !important; /* заокруглені кути */
}

.phone-number {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    text-decoration: none;
    white-space: nowrap;
}

@media screen and (max-width: 901px) {
    .swiper-container .swiper-pagination {
        position: fixed;
        bottom: 0 !important; /* Змініть це значення, щоб контролювати відстань пагінації від верхньої частини Swiper */
        left: 0;
        right: 0;
        text-align: center; /* Щоб центрувати пагінацію */
        padding: 5px 0;
        background-color: #5d1f1f;
        width: 100% !important;
        margin: 0 auto;
    }

    .swiper-nav-btn {
        background-color: transparent;
        width: 40px;
    }
    .swiper-nav-btn svg {
        color: #EE2D2E;
    }

    /* Стилі для айтемів пагінації */
    .swiper-container .swiper-pagination-bullet {
        background-color: #EE2D2E !important; /* червоний фон для айтемів */
        width: auto !important;
        height: auto !important;
        color: white; /* білий текст */
        padding: 2px !important; /* відступи всередині айтема */
        border-radius: 2px !important; /* заокруглені кути */
        font-size: 12px; /* розмір шрифту */
        white-space: nowrap; /* переконайтеся, що текст не переноситься на новий рядок */
        font-weight: bold;
    }

    .swiper-container .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {
        background-color: inherit !important;
        color: #fff !important;
        opacity: 1 !important;
    }

    /* Стилі для активного айтему пагінації */
    .swiper-container .swiper-pagination-bullet-active {
        background-color: #EE2D2E; /* інший колір для активного айтема */
        border-radius: 3px !important; /* заокруглені кути */
    }
}

.mySwiper .swiper-pagination {
    position: absolute;
    bottom: 0 !important; /* Змініть це значення, щоб контролювати відстань пагінації від верхньої частини Swiper */
    left: 0;
    right: 0;
    text-align: center; /* Щоб центрувати пагінацію */
    padding: 10px 0;
    width: 90% !important;
    margin: 0 auto;
}

/* Стилі для айтемів пагінації */
.mySwiper .swiper-pagination-bullet {
    background-color: #EE2D2E !important; /* червоний фон для айтемів */
    color: white; /* білий текст */
    white-space: nowrap; /* переконайтеся, що текст не переноситься на новий рядок */
    font-weight: bold;
}

.mySwiper .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {
    background-color: #ffffff !important;
    color: #fff !important;
    opacity: 1 !important;
}

/* Стилі для активного айтему пагінації */
.mySwiper .swiper-pagination-bullet-active {
    background-color: #000000; /* інший колір для активного айтема */
    border-radius: 5px !important; /* заокруглені кути */
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;IACI;AACJ;;;AAGA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,2JAA2J;AAC/J;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IAEZ,sBAAsB;IACtB,2BAA2B;IAC3B,yDAAsD;AAC1D;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;;AAGA;IACI,kBAAkB;IAClB,oBAAoB,EAAE,yFAAyF;IAC/G,OAAO;IACP,QAAQ;IACR,kBAAkB,EAAE,6BAA6B;IACjD,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB,EAAE,8CAA8C;AACtE;;;AAGA,gCAAgC;AAChC;IACI,oCAAoC,EAAE,6BAA6B;IACnE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY,EAAE,gBAAgB;IAC9B,4BAA4B,EAAE,8BAA8B;IAC5D,6BAA6B,EAAE,qBAAqB;IACpD,eAAe,EAAE,kBAAkB;IACnC,mBAAmB,EAAE,2DAA2D;IAChF,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,yCAAyC;AACzC;IACI,yBAAyB,EAAE,qCAAqC;IAChE,6BAA6B,EAAE,qBAAqB;AACxD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB,EAAE,yFAAyF;QAC/G,OAAO;QACP,QAAQ;QACR,kBAAkB,EAAE,6BAA6B;QACjD,cAAc;QACd,yBAAyB;QACzB,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,6BAA6B;QAC7B,WAAW;IACf;IACA;QACI,cAAc;IAClB;;IAEA,gCAAgC;IAChC;QACI,oCAAoC,EAAE,6BAA6B;QACnE,sBAAsB;QACtB,uBAAuB;QACvB,YAAY,EAAE,gBAAgB;QAC9B,uBAAuB,EAAE,8BAA8B;QACvD,6BAA6B,EAAE,qBAAqB;QACpD,eAAe,EAAE,kBAAkB;QACnC,mBAAmB,EAAE,2DAA2D;QAChF,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;QACpC,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA,yCAAyC;IACzC;QACI,yBAAyB,EAAE,qCAAqC;QAChE,6BAA6B,EAAE,qBAAqB;IACxD;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB,EAAE,yFAAyF;IAC/G,OAAO;IACP,QAAQ;IACR,kBAAkB,EAAE,6BAA6B;IACjD,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,oCAAoC,EAAE,6BAA6B;IACnE,YAAY,EAAE,gBAAgB;IAC9B,mBAAmB,EAAE,2DAA2D;IAChF,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,yCAAyC;AACzC;IACI,yBAAyB,EAAE,qCAAqC;IAChE,6BAA6B,EAAE,qBAAqB;AACxD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway&display=swap');\n\n#app {\n    height: 100%\n}\n\n\nhtml,\nbody {\n    position: relative;\n    height: 100%;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(0, 0, 0, 1) 0%, rgba(38, 11, 11, 1) 0%, rgba(40, 8, 8, 1) 47%, rgba(33, 28, 28, 1) 100%);\n}\n\nbody {\n    font-family: 'Raleway', sans-serif;\n    font-size: 14px;\n    color: #000;\n    margin: 0;\n    padding: 0;\n}\n\nh5 {\n    font-family: 'Raleway', sans-serif;\n}\n\n.logo {\n    height: 90px;\n}\n\n\n.rotateOut {\n    animation: rotateOut 3s linear infinite;\n}\n\n.rotate {\n    animation: rotate 3s linear infinite;\n}\n\n@keyframes rotateOut {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(-360deg);\n    }\n}\n\n@keyframes rotate {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n\n.weight {\n    color: #EE2D2E;\n    font-weight: bold;\n}\n\n.swiper {\n    width: 100%;\n    height: 100%;\n}\n\n.link {\n    color: #fff;\n    text-decoration: none;\n}\n\n.swiper-slide {\n    font-size: 18px;\n    color: #fff;\n    box-sizing: border-box;\n}\n\n.parallax-bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 130%;\n    height: 100%;\n    -webkit-background-size: cover;\n    background-size: cover;\n    background-position: center;\n    background-image: url(\"../src/assets/background1.png\");\n}\n\n\n.swiper-container {\n    position: relative;\n}\n\n.MuiInputLabel-root {\n    color: #fff !important;\n}\n\n.swiper-nav-btn {\n    position: absolute;\n    top: 0;\n    z-index: 100000;\n    height: 100%;\n    width: 100px;\n    border: none;\n    background-color: #0E1513;\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n}\n\n.nav-link {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n}\n\n.swiper-nav-btn:hover {\n    background-color: #3b2b2b;\n}\n\n.loader {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #000;\n    z-index: 1000000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n}\n\n.loader img {\n    width: 100px;\n    height: 100px;\n}\n\n.left-side {\n    left: 0;\n}\n\n.right-side {\n    right: 0;\n}\n\n\n.swiper-container .swiper-pagination {\n    position: absolute;\n    bottom: 0 !important; /* Змініть це значення, щоб контролювати відстань пагінації від верхньої частини Swiper */\n    left: 0;\n    right: 0;\n    text-align: center; /* Щоб центрувати пагінацію */\n    padding: 10px 0;\n    background-color: #5d1f1f;\n    width: 90% !important;\n    margin: 0 auto;\n    z-index: 1000000;\n    border-radius: 5px; /* заокруглені кути, якщо вам це подобається */\n}\n\n\n/* Стилі для айтемів пагінації */\n.swiper-container .swiper-pagination-bullet {\n    background-color: #EE2D2E !important; /* червоний фон для айтемів */\n    width: auto !important;\n    height: auto !important;\n    color: white; /* білий текст */\n    padding: 5px 10px !important; /* відступи всередині айтема */\n    border-radius: 2px !important; /* заокруглені кути */\n    font-size: 20px; /* розмір шрифту */\n    white-space: nowrap; /* переконайтеся, що текст не переноситься на новий рядок */\n    font-weight: bold;\n}\n\n.swiper-container .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {\n    background-color: inherit !important;\n    color: #fff !important;\n    opacity: 1 !important;\n}\n\n/* Стилі для активного айтему пагінації */\n.swiper-container .swiper-pagination-bullet-active {\n    background-color: #EE2D2E; /* інший колір для активного айтема */\n    border-radius: 5px !important; /* заокруглені кути */\n}\n\n.phone-number {\n    color: #fff;\n    font-size: 20px;\n    font-weight: bold;\n    text-decoration: none;\n    white-space: nowrap;\n}\n\n@media screen and (max-width: 901px) {\n    .swiper-container .swiper-pagination {\n        position: fixed;\n        bottom: 0 !important; /* Змініть це значення, щоб контролювати відстань пагінації від верхньої частини Swiper */\n        left: 0;\n        right: 0;\n        text-align: center; /* Щоб центрувати пагінацію */\n        padding: 5px 0;\n        background-color: #5d1f1f;\n        width: 100% !important;\n        margin: 0 auto;\n    }\n\n    .swiper-nav-btn {\n        background-color: transparent;\n        width: 40px;\n    }\n    .swiper-nav-btn svg {\n        color: #EE2D2E;\n    }\n\n    /* Стилі для айтемів пагінації */\n    .swiper-container .swiper-pagination-bullet {\n        background-color: #EE2D2E !important; /* червоний фон для айтемів */\n        width: auto !important;\n        height: auto !important;\n        color: white; /* білий текст */\n        padding: 2px !important; /* відступи всередині айтема */\n        border-radius: 2px !important; /* заокруглені кути */\n        font-size: 12px; /* розмір шрифту */\n        white-space: nowrap; /* переконайтеся, що текст не переноситься на новий рядок */\n        font-weight: bold;\n    }\n\n    .swiper-container .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {\n        background-color: inherit !important;\n        color: #fff !important;\n        opacity: 1 !important;\n    }\n\n    /* Стилі для активного айтему пагінації */\n    .swiper-container .swiper-pagination-bullet-active {\n        background-color: #EE2D2E; /* інший колір для активного айтема */\n        border-radius: 3px !important; /* заокруглені кути */\n    }\n}\n\n.mySwiper .swiper-pagination {\n    position: absolute;\n    bottom: 0 !important; /* Змініть це значення, щоб контролювати відстань пагінації від верхньої частини Swiper */\n    left: 0;\n    right: 0;\n    text-align: center; /* Щоб центрувати пагінацію */\n    padding: 10px 0;\n    width: 90% !important;\n    margin: 0 auto;\n}\n\n/* Стилі для айтемів пагінації */\n.mySwiper .swiper-pagination-bullet {\n    background-color: #EE2D2E !important; /* червоний фон для айтемів */\n    color: white; /* білий текст */\n    white-space: nowrap; /* переконайтеся, що текст не переноситься на новий рядок */\n    font-weight: bold;\n}\n\n.mySwiper .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {\n    background-color: #ffffff !important;\n    color: #fff !important;\n    opacity: 1 !important;\n}\n\n/* Стилі для активного айтему пагінації */\n.mySwiper .swiper-pagination-bullet-active {\n    background-color: #000000; /* інший колір для активного айтема */\n    border-radius: 5px !important; /* заокруглені кути */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
